function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function cov_5jkqvbely() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/helpers/api.ts";
  var hash = "488dab623d72cf48342d638dfb3a537c4e73259d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/helpers/api.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 19
        },
        end: {
          line: 7,
          column: 33
        }
      },
      "1": {
        start: {
          line: 9,
          column: 24
        },
        end: {
          line: 9,
          column: 84
        }
      },
      "2": {
        start: {
          line: 14,
          column: 20
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "3": {
        start: {
          line: 23,
          column: 19
        },
        end: {
          line: 23,
          column: 42
        }
      },
      "4": {
        start: {
          line: 35,
          column: 23
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "5": {
        start: {
          line: 36,
          column: 18
        },
        end: {
          line: 36,
          column: 38
        }
      },
      "6": {
        start: {
          line: 37,
          column: 21
        },
        end: {
          line: 37,
          column: 46
        }
      },
      "7": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "8": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 37
        }
      },
      "9": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 31
        }
      },
      "10": {
        start: {
          line: 42,
          column: 21
        },
        end: {
          line: 42,
          column: 31
        }
      },
      "11": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 56
        }
      },
      "12": {
        start: {
          line: 45,
          column: 29
        },
        end: {
          line: 45,
          column: 54
        }
      },
      "13": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 75
        }
      },
      "14": {
        start: {
          line: 50,
          column: 15
        },
        end: {
          line: 50,
          column: 52
        }
      },
      "15": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 55,
          column: 3
        }
      },
      "16": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 22
        }
      },
      "17": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 59,
          column: 5
        }
      },
      "18": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 38
        }
      },
      "19": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 69
        }
      },
      "20": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 9
        }
      },
      "21": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 83,
          column: 5
        }
      },
      "22": {
        start: {
          line: 87,
          column: 2
        },
        end: {
          line: 109,
          column: 48
        }
      },
      "23": {
        start: {
          line: 109,
          column: 18
        },
        end: {
          line: 109,
          column: 46
        }
      },
      "24": {
        start: {
          line: 113,
          column: 2
        },
        end: {
          line: 148,
          column: 48
        }
      },
      "25": {
        start: {
          line: 148,
          column: 18
        },
        end: {
          line: 148,
          column: 46
        }
      },
      "26": {
        start: {
          line: 173,
          column: 19
        },
        end: {
          line: 205,
          column: 3
        }
      },
      "27": {
        start: {
          line: 207,
          column: 15
        },
        end: {
          line: 207,
          column: 45
        }
      },
      "28": {
        start: {
          line: 209,
          column: 2
        },
        end: {
          line: 211,
          column: 3
        }
      },
      "29": {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 210,
          column: 84
        }
      },
      "30": {
        start: {
          line: 213,
          column: 2
        },
        end: {
          line: 213,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 35,
            column: 23
          },
          end: {
            line: 35,
            column: 24
          }
        },
        loc: {
          start: {
            line: 35,
            column: 97
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 35
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 45,
            column: 22
          },
          end: {
            line: 45,
            column: 23
          }
        },
        loc: {
          start: {
            line: 45,
            column: 29
          },
          end: {
            line: 45,
            column: 54
          }
        },
        line: 45
      },
      "2": {
        name: "handleResponse",
        decl: {
          start: {
            line: 52,
            column: 9
          },
          end: {
            line: 52,
            column: 23
          }
        },
        loc: {
          start: {
            line: 52,
            column: 39
          },
          end: {
            line: 61,
            column: 1
          }
        },
        line: 52
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 56,
            column: 21
          },
          end: {
            line: 56,
            column: 22
          }
        },
        loc: {
          start: {
            line: 56,
            column: 32
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 56
      },
      "4": {
        name: "doBFFPost",
        decl: {
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 65,
            column: 18
          }
        },
        loc: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 84,
            column: 1
          }
        },
        line: 69
      },
      "5": {
        name: "listUnits",
        decl: {
          start: {
            line: 86,
            column: 16
          },
          end: {
            line: 86,
            column: 25
          }
        },
        loc: {
          start: {
            line: 86,
            column: 47
          },
          end: {
            line: 110,
            column: 1
          }
        },
        line: 86
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 109,
            column: 11
          },
          end: {
            line: 109,
            column: 12
          }
        },
        loc: {
          start: {
            line: 109,
            column: 18
          },
          end: {
            line: 109,
            column: 46
          }
        },
        line: 109
      },
      "7": {
        name: "standardizeAddress",
        decl: {
          start: {
            line: 112,
            column: 16
          },
          end: {
            line: 112,
            column: 34
          }
        },
        loc: {
          start: {
            line: 112,
            column: 66
          },
          end: {
            line: 149,
            column: 1
          }
        },
        line: 112
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 148,
            column: 11
          },
          end: {
            line: 148,
            column: 12
          }
        },
        loc: {
          start: {
            line: 148,
            column: 18
          },
          end: {
            line: 148,
            column: 46
          }
        },
        line: 148
      },
      "9": {
        name: "createMortgageLead",
        decl: {
          start: {
            line: 170,
            column: 22
          },
          end: {
            line: 170,
            column: 40
          }
        },
        loc: {
          start: {
            line: 172,
            column: 33
          },
          end: {
            line: 214,
            column: 1
          }
        },
        line: 172
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 55
          },
          end: {
            line: 9,
            column: 69
          }
        }, {
          start: {
            line: 9,
            column: 72
          },
          end: {
            line: 9,
            column: 84
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 18
          },
          end: {
            line: 36,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 18
          },
          end: {
            line: 36,
            column: 33
          }
        }, {
          start: {
            line: 36,
            column: 37
          },
          end: {
            line: 36,
            column: 38
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 21
          },
          end: {
            line: 37,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 21
          },
          end: {
            line: 37,
            column: 39
          }
        }, {
          start: {
            line: 37,
            column: 43
          },
          end: {
            line: 37,
            column: 46
          }
        }],
        line: 37
      },
      "3": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 31
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 42
      },
      "4": {
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 53
      },
      "5": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 53
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 68,
            column: 51
          },
          end: {
            line: 68,
            column: 53
          }
        }],
        line: 68
      },
      "6": {
        loc: {
          start: {
            line: 80,
            column: 22
          },
          end: {
            line: 80,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 22
          },
          end: {
            line: 80,
            column: 50
          }
        }, {
          start: {
            line: 80,
            column: 54
          },
          end: {
            line: 80,
            column: 56
          }
        }],
        line: 80
      },
      "7": {
        loc: {
          start: {
            line: 209,
            column: 2
          },
          end: {
            line: 211,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 2
          },
          end: {
            line: 211,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 209
      },
      "8": {
        loc: {
          start: {
            line: 210,
            column: 20
          },
          end: {
            line: 210,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 210,
            column: 20
          },
          end: {
            line: 210,
            column: 46
          }
        }, {
          start: {
            line: 210,
            column: 50
          },
          end: {
            line: 210,
            column: 82
          }
        }],
        line: 210
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "488dab623d72cf48342d638dfb3a537c4e73259d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_5jkqvbely = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_5jkqvbely();
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import * as Cookies from 'js-cookie';
import { globalObservability } from '@opendoor/observability/slim';
import { getDeployEnv } from "./globals.mjs";
var DEPLOY_ENV = (cov_5jkqvbely().s[0]++, getDeployEnv());
var XSRF_COOKIE_KEY = (cov_5jkqvbely().s[1]++, DEPLOY_ENV !== 'development' ? (cov_5jkqvbely().b[0][0]++, 'XSRF-G-TOKEN') : (cov_5jkqvbely().b[0][1]++, 'XSRF-TOKEN'));

// Hit staging Athena by default in development
//
// To hit local Athena invert the comment & uncommented `development` keys
var ATHENA_URLS = (cov_5jkqvbely().s[2]++, {
  production: 'https://graphql.apps.opendoor.com/api/graphql',
  // development: 'http://localhost:4000/api/graphql',
  development: 'https://graphql.simplersell.com/api/graphql',
  // development: 'http://athena-api-nginx-vpn-http.apps.internal.opendoor.com/api/graphql',
  qa: 'https://graphql.simplersell.com/api/graphql',
  staging: 'https://graphql.simplersell.com/api/graphql',
  test: 'https://graphql.simplersell.com/api/graphql'
});
var ATHENA_URL = (cov_5jkqvbely().s[3]++, ATHENA_URLS[DEPLOY_ENV]);
/**
 * A wrapper around `fetch` with optional retries.
 * Retries up to `options.retries` times (defaults to `5` if not specified)
 * with a delay of `options.retryDelay` (defaults to `500ms` if not specified)
 */
cov_5jkqvbely().s[4]++;
var _fetchWithRetry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, options) {
    var retries, retryDelay, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          cov_5jkqvbely().f[0]++;
          retries = (cov_5jkqvbely().s[5]++, (cov_5jkqvbely().b[1][0]++, options.retries) || (cov_5jkqvbely().b[1][1]++, 0));
          retryDelay = (cov_5jkqvbely().s[6]++, (cov_5jkqvbely().b[2][0]++, options.retryDelay) || (cov_5jkqvbely().b[2][1]++, 500));
          cov_5jkqvbely().s[7]++;
          _context.p = 1;
          cov_5jkqvbely().s[8]++;
          _context.n = 2;
          return fetch(url, options);
        case 2:
          return _context.a(2, _context.v);
        case 3:
          _context.p = 3;
          _t = _context.v;
          cov_5jkqvbely().s[9]++;
          if (!(retries < 1)) {
            _context.n = 4;
            break;
          }
          cov_5jkqvbely().b[3][0]++;
          cov_5jkqvbely().s[10]++;
          throw _t;
        case 4:
          cov_5jkqvbely().b[3][1]++;
        case 5:
          cov_5jkqvbely().s[11]++;
          _context.n = 6;
          return new Promise(function (r) {
            cov_5jkqvbely().f[1]++;
            cov_5jkqvbely().s[12]++;
            return setTimeout(r, retryDelay);
          });
        case 6:
          cov_5jkqvbely().s[13]++;
          _context.n = 7;
          return _fetchWithRetry(url, _objectSpread(_objectSpread({}, options), {}, {
            retries: retries - 1
          }));
        case 7:
          return _context.a(2, _context.v);
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function fetchWithRetry(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var Sentry = (cov_5jkqvbely().s[14]++, globalObservability.getSentryClient());
function handleResponse(res) {
  var _Sentry$withScope;
  cov_5jkqvbely().f[2]++;
  cov_5jkqvbely().s[15]++;
  if (res.ok) {
    cov_5jkqvbely().b[4][0]++;
    cov_5jkqvbely().s[16]++;
    return res.json();
  } else {
    cov_5jkqvbely().b[4][1]++;
  }
  cov_5jkqvbely().s[17]++;
  (_Sentry$withScope = Sentry.withScope) === null || _Sentry$withScope === void 0 || _Sentry$withScope.call(Sentry, function (scope) {
    var _Sentry$captureMessag;
    cov_5jkqvbely().f[3]++;
    cov_5jkqvbely().s[18]++;
    scope.setExtras({
      resonse: res
    });
    cov_5jkqvbely().s[19]++;
    (_Sentry$captureMessag = Sentry.captureMessage) === null || _Sentry$captureMessag === void 0 || _Sentry$captureMessag.call(Sentry, 'Non-200 response received in api call');
  });
  cov_5jkqvbely().s[20]++;
  return;
}

// To do: strengthen jsonParam's type
// Do not pass skip doBFFPost as it will not actually skip making the request - instead handle it conditionally
function doBFFPost(apiUrl, jsonParams) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_5jkqvbely().b[5][0]++, {});
  cov_5jkqvbely().f[4]++;
  cov_5jkqvbely().s[21]++;
  return _fetchWithRetry(apiUrl, _objectSpread(_objectSpread({
    retries: 5,
    retryDelay: 500,
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(jsonParams)
  }, options), {}, {
    headers: _objectSpread({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': (cov_5jkqvbely().b[6][0]++, Cookies.get(XSRF_COOKIE_KEY)) || (cov_5jkqvbely().b[6][1]++, '')
    }, options.headers)
  }));
}
export function listUnits(addressUUID) {
  cov_5jkqvbely().f[5]++;
  cov_5jkqvbely().s[22]++;
  return doBFFPost(ATHENA_URL, {
    operationName: 'ListUnits',
    query: "query ListUnits($addressUUID: String!, $limit: Float!) {\n        casa {\n          listUnits(input: { uuid: $addressUUID, limit: $limit }) {\n            addresses{\n              uuid\n              result\n            }\n          }\n        }\n      }",
    variables: {
      addressUUID: addressUUID,
      limit: 10
    }
  }, {
    headers: {
      'apollographql-client-name': 'cinderblocks'
    }
  }).then(handleResponse)["catch"](function (e) {
    var _Sentry$captureExcept;
    cov_5jkqvbely().f[6]++;
    cov_5jkqvbely().s[23]++;
    return (_Sentry$captureExcept = Sentry.captureException) === null || _Sentry$captureExcept === void 0 ? void 0 : _Sentry$captureExcept.call(Sentry, e);
  });
}
export function standardizeAddress(address) {
  cov_5jkqvbely().f[7]++;
  cov_5jkqvbely().s[24]++;
  return doBFFPost(ATHENA_URL, {
    operationName: 'StandardizeAddress',
    query: "query StandardizeAddress($address: OdProtosCasaServices_CasaRequest_FindByFieldsInput!) {\n      casa {\n        findByFields(input: $address) {\n          address {\n            uuid\n            street\n            city\n            state\n            unitNumber\n            unitType\n            postalCode\n            latitude\n            longitude\n            result\n          }\n        }\n      }\n    }",
    variables: {
      address: {
        city: address.city,
        postalCode: address.postal_code,
        state: address.state,
        street: address.street1,
        unitNumber: address.unit
      }
    }
  }, {
    headers: {
      'apollographql-client-name': 'cinderblocks'
    }
  }).then(handleResponse)["catch"](function (e) {
    var _Sentry$captureExcept2;
    cov_5jkqvbely().f[8]++;
    cov_5jkqvbely().s[25]++;
    return (_Sentry$captureExcept2 = Sentry.captureException) === null || _Sentry$captureExcept2 === void 0 ? void 0 : _Sentry$captureExcept2.call(Sentry, e);
  });
}

// Mortgage Lead Flow API

export function createMortgageLead(_x3) {
  return _createMortgageLead.apply(this, arguments);
}
function _createMortgageLead() {
  _createMortgageLead = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(input) {
    var _data$data;
    var response, data, _data$errors;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          cov_5jkqvbely().f[9]++;
          cov_5jkqvbely().s[26]++;
          _context2.n = 1;
          return doBFFPost(ATHENA_URL, {
            operationName: 'CreateMortgageLead',
            query: "mutation CreateMortgageLead($input: MortgageLeadInput!) {\n        mortgage {\n          createLead(input: $input) {\n            success\n          }\n        }\n      }",
            variables: {
              input: {
                customerUuid: input.customerUuid,
                addressToken: input.addressToken,
                propertyType: input.propertyType,
                targetMoveDate: input.targetMoveDate,
                targetPrice: input.targetPrice,
                targetDownPayment: input.targetDownPayment,
                targetLocation: input.targetLocation,
                employmentStatus: input.employmentStatus,
                householdIncomeMin: input.householdIncomeMin,
                householdIncomeMax: input.householdIncomeMax,
                firstName: input.firstName,
                lastName: input.lastName,
                phone: input.phone,
                email: input.email,
                currentAddress: input.currentAddress
              }
            }
          }, {
            headers: {
              'apollographql-client-name': 'cinderblocks'
            }
          });
        case 1:
          response = _context2.v;
          cov_5jkqvbely().s[27]++;
          _context2.n = 2;
          return handleResponse(response);
        case 2:
          data = _context2.v;
          cov_5jkqvbely().s[28]++;
          if (data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && (_data$data = _data$data.mortgage) !== null && _data$data !== void 0 && (_data$data = _data$data.createLead) !== null && _data$data !== void 0 && _data$data.success) {
            _context2.n = 3;
            break;
          }
          cov_5jkqvbely().b[7][0]++;
          cov_5jkqvbely().s[29]++;
          throw new Error((cov_5jkqvbely().b[8][0]++, data === null || data === void 0 || (_data$errors = data.errors) === null || _data$errors === void 0 || (_data$errors = _data$errors[0]) === null || _data$errors === void 0 ? void 0 : _data$errors.message) || (cov_5jkqvbely().b[8][1]++, 'Failed to create mortgage lead'));
        case 3:
          cov_5jkqvbely().b[7][1]++;
        case 4:
          cov_5jkqvbely().s[30]++;
          return _context2.a(2, {
            success: true
          });
      }
    }, _callee2);
  }));
  return _createMortgageLead.apply(this, arguments);
}
//# sourceMappingURL=api.mjs.map